/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_P1Inputs */

const tr_iade_iptal_s9_p1 = /** @type {(inputs: Iade_Iptal_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone, aşağıdaki kanallardan herhangi birini kullanarak fesih bildiriminde bulunabilir. Tüm kanallar eşit hukuki etkiye sahiptir:`)
};

const en_iade_iptal_s9_p1 = /** @type {(inputs: Iade_Iptal_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Subscriber may give a termination notice using any of the following channels. All channels have equal legal effect:`)
};

const de_iade_iptal_s9_p1 = /** @type {(inputs: Iade_Iptal_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Abonnent kann die Beendigung über einen beliebigen der folgenden Kanäle mitteilen. Alle Kanäle haben dieselbe rechtliche Wirkung:`)
};

const ru_iade_iptal_s9_p1 = /** @type {(inputs: Iade_Iptal_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абонент может подать уведомление о расторжении по любому из следующих каналов. Все каналы имеют одинаковую юридическую силу:`)
};

/**
* | output |
* | --- |
* | "The Subscriber may give a termination notice using any of the following channels. All channels have equal legal effect:" |
*
* @param {Iade_Iptal_S9_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_p1 = /** @type {((inputs?: Iade_Iptal_S9_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_p1(inputs)
	if (locale === "de") return de_iade_iptal_s9_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_p1(inputs)
	return tr_iade_iptal_s9_p1(inputs)
});